/* src/app/shared/components/logo-dd/logo-dd.component.scss */
.dd-logo.tm {
  position: relative;
}
.dd-logo.tm::after {
  content: "TM";
  font-size: 0.2em;
  line-height: 1;
  position: absolute;
  right: -0.35em;
  bottom: 3.5em;
}
:host(.logo-dd) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
}
/*# sourceMappingURL=logo-dd.component.css.map */
